module.exports = __webpack_public_path__ + "static/img/buttonImmediately.f9d296f7.png";